import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
import DataTable from '../../Common/DataTable';
import AddZipCodeModal from './components/AddZipCodeModalComponent/AddZipCodeModal';
import { ZipCodeTableColumns } from './utils/types';
import { getAllPincode } from '../../redux/masters/masterSlice';
import { setLoader } from '../../redux/loaderSlice';
import { RootState } from '../../redux/rootState';
import { defaultPageSize } from '../../utils/Constant';

function ZipCodes() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  const [showUserModal, setShowUserModal] = useState(false);
  const { isLoading, allPincodeList } = useSelector((state: RootState) => state.masterDataReducer);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleData = () => {
    const payload = {
      pageSize: rowsPerPage,
      searchItem: searchQuery,
      pageNumber: page,
      sortColumn,
      sortDirection,
    };
    dispatch(getAllPincode(payload));
  };

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortColumn, sortDirection]);

  //   const downloadExcel = () => {
  //     const exportedData = userManagementListData?.Data?.map((items, index) => ({
  //       SN: index + 1,
  //       UserId: items?.Email,
  //       Initials: items?.Initials,
  //       Role: items?.UserRole,
  //       Status: items?.Status,
  //     }));
  //     exportToExcelData(
  //       {
  //         data: exportedData?.length > 0 ? exportedData : [],
  //       },
  //       'USER MANAGEMENT',
  //     );
  //   };

  const tableData = useMemo(() => {
    if (allPincodeList?.PinCodes?.length > 0) {
      // eslint-disable-next-line arrow-body-style
      const transformedData = allPincodeList?.PinCodes?.map((item, index) => {
        return {
          pinCode: item?.Pincode,
          stateCode: item?.StateCode,
          cityName: item?.CityName,
          countryCode: item?.CountryCode,
          id: String(index + 1),
        };
      });
      return transformedData;
    }
    return [];
  }, [allPincodeList?.PinCodes]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <ComponentPageHeader subHeading="ZIP CODES" />
          {/* <ComponentPageHeader subHeading="ZIP CODES" downloadExcel={() => {}} /> */}
        </Grid>
        <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
          {/* <DataTable<ZipCodeListingInterface> */}
          <DataTable
            data={tableData}
            columns={ZipCodeTableColumns}
            totalRecords={allPincodeList?.TotalCount}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            searchQuery={searchQuery}
            setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
            sortCol={sortColumn}
            setSortCol={(e) => { setSortColumn(e); setPage(1); }}
            sortDir={sortDirection}
            setSortDir={(e) => { setSortDirection(e); setPage(1); }}
            handleData={handleData}
            buttonText="Add new Zip"
            handleButtonClick={() => {
              setShowUserModal(true);
            }}
            handleDataFromComponent
          />
        </Grid>
      </Grid>
      {showUserModal
        && (
          <AddZipCodeModal
            show={showUserModal}
            setOpenFrom={() => setShowUserModal(false)}
          />
        )}
    </>
  );
}

export default ZipCodes;
